import $http from '@common-vue/util/src/modules/http';

const API_ENDPOINTS = {
  PDP: 'xapi/digital',
};
const API_VERSION = 'v1';
const API_PDP_BASE_URL = `${API_ENDPOINTS.PDP}/${API_VERSION}`;

const _get = async (url) => {
  if (!url) {
    throw new Error(`apiCLient get(): url attr is required, url: ${url}`);
  }

  let results;

  try {
    results = await $http.get(url);
  } catch (error) {
    throw new Error(`apiCLient get(): ${error}`);
  }

  if (!results.data) {
    throw new Error('apiCLient get(): results.data is empty');
  }

  return results.data;
};

const getPdpProductById = ({
  id,
  size = 'small',
  isSSR,
  hostlink,
} = {}) => {
  if (!id) {
    throw new Error(`getPdpProductById(): API Request Failed: params.id is required. params.id: ${id}`);
  }

  const url = `${isSSR ? hostlink : ''}/${API_PDP_BASE_URL}/product/${id}?size=${size}`;

  return _get(url);
};

export { getPdpProductById };

export default {};
